(() => {
  const SOURCE_ID = 'PeakStyleCategoryRegistry';
  const READY_EVENT = 'peakstyle:category-registry-ready';
  const source = document.getElementById(SOURCE_ID);
  if (!source || window.PeakStyleCategoryRegistry?.tree?.length) return;

  const normalize = (value) => String(value || '')
    .trim()
    .toLocaleLowerCase('de')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/ß/g, 'ss')
    .replace(/[^a-z0-9]+/g, '');

  let raw;
  try {
    raw = JSON.parse(source.textContent || '[]');
  } catch (error) {
    console.warn('[PeakStyle] Zentrale Kategoriequelle ist ungültig.', error);
    return;
  }

  const nodes = raw
    .filter((entry) => entry && entry.enabled !== false && /^category:.+_lvl_[1-5]$/i.test(String(entry.tag || '')))
    .map((entry) => ({
      key: String(entry.key || ''),
      parentKey: String(entry.parentKey || ''),
      parentTag: String(entry.parentTag || ''),
      title: String(entry.label || ''),
      label: String(entry.label || ''),
      tag: String(entry.tag || ''),
      level: Number(entry.level) || 0,
      url: String(entry.url || '/collections/all'),
      handle: String(entry.tag || '').replace(/^category:/i, '').replace(/_lvl_[1-5]$/i, ''),
      sortOrder: Number(entry.sortOrder) || 0,
      count: Math.max(0, Number(entry.count) || 0),
      knownAvailable: Number(entry.count) > 0,
      registryManaged: true,
      children: []
    }));

  const byKey = new Map(nodes.map((node) => [node.key, node]));
  const byTag = new Map();
  nodes.forEach((node) => {
    if (!byTag.has(node.tag)) byTag.set(node.tag, []);
    byTag.get(node.tag).push(node);
  });

  const roots = [];
  nodes.forEach((node) => {
    const parent = node.parentKey ? byKey.get(node.parentKey) : null;
    if (parent && node.level === parent.level + 1) parent.children.push(node);
    else if (node.level === 1) roots.push(node);
  });

  const sortTree = (entries) => {
    entries.sort((left, right) =>
      left.sortOrder - right.sortOrder ||
      left.title.localeCompare(right.title, 'de', { sensitivity: 'base' })
    );
    entries.forEach((entry) => sortTree(entry.children));
  };
  sortTree(roots);

  const findPaths = (tag, entries = roots, path = [], matches = []) => {
    entries.forEach((node) => {
      const next = [...path, node];
      if (node.tag === tag) matches.push(next);
      findPaths(tag, node.children, next, matches);
    });
    return matches;
  };

  const resolvePath = (tags = [], labels = []) => {
    const activeTags = new Set((tags || []).map(String));
    const normalizedLabels = (labels || []).map(normalize).filter(Boolean);
    const candidates = [];
    [...activeTags].forEach((tag) => findPaths(tag).forEach((path) => candidates.push(path)));
    return candidates
      .filter((path) => path.every((node, index) => node.level === index + 1))
      .map((path) => ({
        path,
        score: path.reduce((sum, node, index) => {
          const tagScore = activeTags.has(node.tag) ? 10 : 0;
          const labelScore = normalizedLabels[index] && normalize(node.title) === normalizedLabels[index] ? 4 : 0;
          return sum + tagScore + labelScore;
        }, 0)
      }))
      .sort((left, right) => right.score - left.score || right.path.length - left.path.length)[0]?.path || [];
  };

  const audienceKey = 'filter.p.m.custom.audience_reference';
  const withAudience = (rawUrl, values = []) => {
    if (!rawUrl || !values.length) return rawUrl;
    const url = new URL(rawUrl, window.location.origin);
    url.searchParams.delete(audienceKey);
    values.forEach((value) => url.searchParams.append(audienceKey, value));
    return url.pathname + url.search + url.hash;
  };

  const registry = { nodes, tree: roots, byKey, byTag, normalize, findPaths, resolvePath, withAudience };
  window.PeakStyleCategoryRegistry = registry;
  document.dispatchEvent(new CustomEvent(READY_EVENT, { detail: registry }));

  const parseJson = (root, selector, fallback = []) => {
    const element = root.querySelector(selector);
    if (!element) return fallback;
    try { return JSON.parse(element.textContent || ''); } catch (error) { return fallback; }
  };

  const patchProductBreadcrumbs = () => {
    document.querySelectorAll('[data-peakstyle-product-category-breadcrumb]').forEach((target) => {
      if (target.dataset.psRegistryReady === 'true') return;
      const tags = parseJson(target, '[data-peakstyle-product-category-tags]');
      const labels = parseJson(target, '[data-peakstyle-product-category-labels]');
      const path = resolvePath(tags, labels);
      if (!path.length) return;

      const separator = target.querySelector('.breadcrumbs--sep')?.cloneNode(true);
      if (!separator) return;
      const fragment = document.createDocumentFragment();
      path.forEach((node) => {
        fragment.appendChild(separator.cloneNode(true));
        const link = document.createElement('a');
        let href = node.url;
        if (target.dataset.contextFilterable === 'true' && target.dataset.contextBaseUrl) {
          const contextUrl = new URL(target.dataset.contextBaseUrl, window.location.origin);
          contextUrl.searchParams.set('filter.p.tag', node.tag);
          href = contextUrl.pathname + contextUrl.search;
        }
        const audienceValues = new URL(window.location.href).searchParams.getAll(audienceKey);
        link.href = withAudience(href, audienceValues);
        link.textContent = node.title;
        fragment.appendChild(link);
      });
      target.replaceChildren(fragment);
      target.dataset.psRegistryReady = 'true';
    });
  };
  patchProductBreadcrumbs();
  document.addEventListener('shopify:section:load', patchProductBreadcrumbs);
})();